import { useEffect } from 'react';
import { InputViewModel } from '@sitecore-jss/sitecore-jss-forms';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import { NextRouter } from 'next/router';

const ChineseRecaptchaStubInput: React.FC<
  ValueFieldProps<InputViewModel> & { router: NextRouter }
> = (props) => {
  const { field, fieldValidationErrorsComponent, onChange } = props;
  const { id, name } = field.valueField;
  const bypassToken = 'CHINA_LOCALE_RECAPTCHA_BYPASS';

  useEffect(() => {
    // Send a bypass token to fulfill the required field validation
    onChange(name, bypassToken, true, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const FieldValidationErrors = fieldValidationErrorsComponent;

  return (
    <>
      <input id={id} name={name} type="hidden" value={bypassToken} />
      {!!FieldValidationErrors && <FieldValidationErrors {...props} />}
    </>
  );
};
export default ChineseRecaptchaStubInput;
